import React from 'react';

import Button from 'components/shared/Button/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const EprescribeConfirmationModal = ({
  isOpen,
  onClose,
  onMarkCompleted,
  onContinueActivation,
  onSkip,
  isLoadingActivation
}) => {
  return (
    <Confirm
      isOpen={isOpen}
      handleClose={onClose}
      handleContinue={() => {}}
      title="E-prescribing not activated"
      message="You haven't activated e-prescribing yet. Choose how you'd like to proceed before moving on."
      icon="info-filled"
      iconColor="primary"
      footer={
        <>
          <Button
            text="Mark complete"
            size="small"
            color="danger"
            variant="link"
            onClick={onMarkCompleted}
            isDisabled={isLoadingActivation}
          />
          <Button
            text="Skip for now"
            size="small"
            style="outlined"
            color="neutral"
            onClick={onSkip}
            isDisabled={isLoadingActivation}
          />
          <Button
            text="Activate e-prescribing"
            size="small"
            onClick={onContinueActivation}
            isLoading={isLoadingActivation}
          />
        </>
      }
    />
  );
};

export default EprescribeConfirmationModal;
